import React from "react";
import { ShowMoreParcours } from "./StyledComponents/ShowMore.style";
import MoreParcoursVideo from "./asset/video/MoreParcoursVideo.mp4";
import ImgFond from "./asset/pictures/pers_drawMyLife.png";

const MoreParcours = () => {
  return (
    <>
      <ShowMoreParcours backgroundImg={ImgFond}>
        <video src={MoreParcoursVideo} controls />
      </ShowMoreParcours>
    </>
  );
};

export default MoreParcours;
